// extracted by mini-css-extract-plugin
module.exports = {"collection":"TagCollection_collection__2aGqU","expanded":"TagCollection_expanded__xA4P7","collectionTag":"TagCollection_collectionTag__1wOlE"};